import React, { useEffect, useRef, useMemo } from 'react';
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
} from 'reactstrap';

import Notification from '../../components/Notification';
import TableManager from '../../components/TableManager';
import { useManager } from '../../hooks/manager';
import LayoutAdmin from '../../layouts/admin';

function UsersJustificados() {
  const notificationRef = useRef();
  const { load, destroy } = useManager();

  useEffect(() => {
    load('/justificativas');
  }, [load]);

  const columns = useMemo(() => [
    {
      dataField: 'sessao.nome',
      text: 'Sessão',
      textFilter: true,
    },
    {
      dataField: 'user.name',
      text: 'Nome',
      textFilter: true,
    },
    {
      dataField: 'user.cim',
      text: 'CIM',
      textFilter: true,
    },
    {
      dataField: 'observacoes',
      text: 'Observações',
      textFilter: true,
    },
  ], []);

  return (
    <LayoutAdmin>
      <Notification ref={notificationRef} />
      <Container>
        <Row className="mt-5">
          <Col>
            <Card>
              <CardBody>
                <Row>
                  <Col>
                    <h3>Usuário Justificados</h3>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <TableManager
              columns={columns}
              onDelete={(row) => destroy(row.id, '/justificativas')}
            />
          </Col>
        </Row>
      </Container>
    </LayoutAdmin>
  );
}

export default UsersJustificados;
